import React from 'react';

import { FlyBlinker } from '@fly/shared-ui';
import { FlySvgSprite } from '@fly/svg';
import { Skeleton } from '@radix-ui/themes';
import cn from 'classnames';

import styles from './Deployment.module.less';

export const DeploymentCardSkeleton = ({
  isFirst = false,
  isLast = false,
}: {
  isFirst?: boolean;
  isLast?: boolean;
}) => {
  return (
    <div
      className={cn(styles.deploymentItem, isLast && styles.deploymentItemLast)}
    >
      <div className='h-8 w-8 bg-gray-3 absolute top-fly-2 left-[50px] z-3 flex items-center justify-center rounded-full'>
        {isFirst ? (
          <FlyBlinker size='2' color='grass' />
        ) : (
          <FlySvgSprite name='rocket' size={18} />
        )}
      </div>
      <div
        data-testid='runtime-deployment-skeleton'
        className='bg-gray-3 rounded-4 flex min-h-[48px] w-full flex-col gap-fly-4 overflow-hidden pt-fly-3 pr-fly-5 pb-fly-3 pl-fly-5'
      >
        <div className='gap-fly-43 flex cursor-pointer items-center'>
          <div className='flex w-full flex-1 flex-row items-center gap-fly-3'>
            <Skeleton className='h-6 w-[30%]' />
          </div>
        </div>
        <Skeleton className='h-7 w-full' />
      </div>
    </div>
  );
};
